import { AccountStatus } from './AtoGeneral.model';
import { InstagramPostModel } from './AtoInstagramPost.model';

export enum AtoErrorCodes {
    VALIDATION_ERROR1 = 32001,
    VALIDATION_ERROR2 = 32002,
    DATABASE_ERROR = 32701,
    COMMUNICATION_ERROR = 32801,
    PROCESSING_ERROR = 39001,
    ALREADY_HAS_IDENTITY = 40011,
    INVALID_SERVICE_PROVIDER = 40012,
    IDENTITY_NOT_FOUND = 40013,
    SERVICE_NOT_FOUND = 40014,
    SERVICE_ALREADY_LINKED = 40015,
    SERVICE_EXPIRED = 40016,
    SERVICE_AUTH_NOT_STARTED = 40401,
    INVALID_SERVICE_PROVIDER_ACCOUNT = 40402,
    INVALID_SERVICE_SCOPES = 40403,
    NO_SUBSCRIPTIONS = 40017,
    TOKEN_NOT_FOUND = 40111,
    EVENT_NOT_FOUND = 40201,
    INVALID_EVENT_GROUP = 40202,
    PRECONDITION_FAILED = 40290,
    NO_SERVICE_PROVIDER_ACCOUNT_FOUND = 40404,
    DEFAULT = 104
}

export interface ErrorInterface {
    title: string;
    desc: string;
}

export type ErrorCodes2TextsMapping = {
    [key in AtoErrorCodes]?: {
        [key in AtoProviders]?: ErrorInterface
    } & {
        default?: ErrorInterface;
    }
};

export enum AtoProviders {
    YOUTUBE = 'youtube',
    INSTAGRAM = 'instagram',
    FACEBOOK = 'facebook'
}

export enum AtoServiceStatus {
    REVOKED = 'revoked',
    INIT = 'init'
}

export interface AtoComputedServiceInfoModel {
    avatar_display_url: string;
    banner_display_url?: string;
    account_handle?: string;
    account_name: string;
    account_name_and_handle: string;
    last_three_posts_urls?: string[];
    followers_count: number;
}

export interface AtoYoutubeServiceInfoModel {
    avatar_binary_data?: string;
    avatar_url?: string;
    banner_url?: string;
    banner_binary_data?: string;
    channel_creation_date?: Date;
    channel_description?: string;
    channel_handle?: string;
    channel_id?: string
    channel_name?: string;
    last_three_videos_data?: ServiceVideoDataModel[];
    posting_frequency?: number;
    provider?: AtoProviders
    subscriber_count?: number;
    video_count?: number;
    playlist_count?: number;
    view_count?: string;
    initial_scan_date?: Date;
    last_scan_date?: Date;
}

export interface AtoInstagramServiceInfoModel {
    biography: string;
    followers_count: number;
    follows_count: number;
    initial_scan_date: Date;
    last_scan_date: Date;
    name: string;
    posts_and_reels_count: number;
    profile_picture_url: string;
    profile_picture_url_bd_url: string;
    scan_count: number;
    username: string;
    website: string;
    last_three_posts_and_reels: InstagramPostModel[];
}

export interface AtoFacebookServiceInfoModel  {
    name: string,
    username?: string,
    description?: string,
    like_count: number,
    follower_count: number,
    cover_link: string,
    avatar_link: string,
    avatar_link_bd_url: string,
    cover_link_bd_url: string,
    post_number: number,
    scan_count: number;
    initial_scan_date: Date;
    last_scan_date: Date;
    last_three_posts: {
        text: string,
        image_url: string,
        created_time: string,
        image_url_bd_url: string,
    }[],
}

interface BaseAtoServiceModel {
    service_id: string,
    provider: AtoProviders,
    linked: boolean;
    status: AtoServiceStatus;
    _computedServiceInfo: AtoComputedServiceInfoModel
    _computedAccountStatus: AccountStatus;
    _computedCriticalRecomendationsNo: number;
    _computedRecomendationsNo: number;
    provider_user_id?: string;
    provider_accounts?: ProviderChannel[];
}

interface AtoYoutubeServiceModel extends BaseAtoServiceModel {
    provider: AtoProviders.YOUTUBE;
    service_info: AtoYoutubeServiceInfoModel,
}

interface AtoInstagramServiceModel extends BaseAtoServiceModel {
    provider: AtoProviders.INSTAGRAM;
    service_info: AtoInstagramServiceInfoModel,
}

interface AtoFacebookServiceModel extends BaseAtoServiceModel {
    provider: AtoProviders.FACEBOOK;
    service_info: AtoFacebookServiceInfoModel,
}

export type AtoServiceModel = AtoYoutubeServiceModel | AtoInstagramServiceModel | AtoFacebookServiceModel;

export interface ServiceVideoDataModel {
    description: string;
    maxres_url: string;
    publishedAt: Date;
    standard_quality_binary: string;
    title: string;
    video_id: string;
    default_url: string;
    high_url: string;
    medium_url: string;
    standard_quality_binary_url: string;
    standard_url: string;
    display_url: string;
}

export interface ProviderChannel {
    id: string;
    name: string;
    username?: string;
    picture?: string;
    provider_user_type?: string;
}
